/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Signals from '../../signals/Signals';

import FormGroup from '../../components/ui/FormGroup/FormGroup';
import FormField from '../../components/ui/FormField/FormField';

import companyUpdate from '../../requests/companyUpdate';
import DateInput from '../../components/ui/DateInput/DateInput';
import { _formatDate } from '../../utils/objectToFormData';

/**
 *
 */
class OnBoardingCompanyKVK extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = { errors: null, submitting: false };

		this.onSkip = this.onSkip.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onSubmitError = this.onSubmitError.bind(this);

		this.onInputChange = this.onInputChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const formClasses = classNames({ 'form--submitting': this.state.submitting });

		return (
			<div className={`panel border border--dark ${this.props.className}`}>
				<form
					className={`on-boarding__form ${formClasses}`}
					name="on-boarding"
					onSubmit={this.onSubmit}>
					<div className="on-boarding__header padding border--bottom border--dark">
						<h2>
							<FormattedMessage
								id="onboarding.company.kvk.title"
								values={{ name: this.props.company.name }}
							/>
						</h2>
					</div>

					<div className="padding-small">
						<FormGroup errors={this.state.errors}>
							<FormField className="col--12">
								<label>
									<FormattedMessage id="onboarding.field.company.kvk" />
								</label>
								<input
									type="text"
									name="kvkNumber"
									required
									value={
										this.state.kvkNumber !== undefined
											? this.state.kvkNumber
											: this.props.company.kvkNumber
									}
									onChange={this.onInputChange}
								/>
							</FormField>

							<FormField className="col--12">
								<label>
									<FormattedMessage id="onboarding.field.company.activity" />
								</label>
								<input
									name="activity"
									type="text"
									maxLength="255"
									required
									value={
										this.state.activity !== undefined
											? this.state.activity
											: this.props.company.activity
									}
									onChange={this.onInputChange}
								/>
							</FormField>

							<FormField className="col--12 form-field__date-picker">
								<label>
									<FormattedMessage id="onboarding.field.company.startcompany" />
								</label>
								<DateInput
									name="startCompany"
									required
									value={
										this.state.startCompany !== undefined
											? this.state.startCompany
											: this.props.company.startCompany
									}
									onChange={this.onDateChange}
								/>
							</FormField>
						</FormGroup>
					</div>

					<div className="options-footer border--top border--dark grid grid--spread">
						<button
							type="button"
							className="on-boarding__skip-button button--tertiary"
							onClick={this.onSkip}>
							{this.props.intl.formatMessage({ id: 'onboarding.form.skip' })}
						</button>
						<input
							className="on-boarding__submit-button"
							type="submit"
							value={this.props.intl.formatMessage({ id: 'onboarding.form.submit' })}
						/>
					</div>
				</form>
			</div>
		);
	}

	/**
	 *
	 * @param e
	 * @param date
	 */
	onDateChange(e, date) {
		this.state.startCompany = date;
		this.forceUpdate();
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		this.state[e.target.name] = e.target.value;
		this.forceUpdate();
	}

	/**
	 *
	 */
	onSkip() {
		this.props.successCallback();
	}

	/**
	 *
	 * @param e
	 */
	onSubmit(e) {
		e.preventDefault();

		if (this.state.submitting) {
			return;
		}

		const data = {};
		for (const key in this.state) {
			if (this.state.hasOwnProperty(key)) {
				switch (key) {
					case 'startCompany':
						data[key] = _formatDate(this.state[key]);
						break;
					case 'errors':
					case 'submitting':
						// do nothing
						break;
					default:
						data[key] = this.state[key];
				}
			}
		}

		this.setState({ errors: null, submitting: true });
		companyUpdate(this.props.company.id, data).then(this.onSubmitSuccess).catch(this.onSubmitError);
	}

	/**
	 *
	 * @param response
	 */
	onSubmitSuccess(response) {
		this.setState({ submitting: false });
		this.props.company.update(response.data);
		this.props.successCallback(this);
	}

	/**
	 *
	 * @param error
	 */
	onSubmitError(error) {
		this.setState({ submitting: false });
		if (error.response && error.response.body) {
			this.setState({ errors: error.response.body });
		} else {
			Signals.Error.dispatch(error);
		}
	}
}

OnBoardingCompanyKVK.propTypes = {
	intl: PropTypes.object,
	company: PropTypes.object.isRequired,
	successCallback: PropTypes.func.isRequired,
	className: PropTypes.string
};

export default injectIntl(OnBoardingCompanyKVK);
